'use strict';

const appendParamToURL = require('../modules/util/appendParamToURL');
const damHelper = require('../dam/dam-helper');

const paginator = '.js-paginator';
const pageNumber = '.js-page-number';
const previousPage = '.js-previous-page';
const nextPage = '.js-next-page';

function initialize() {
    $('.js-order-history-spinner').removeClass('spinner-visible');
    $('.js-orders-page-0').removeClass('hide');
    $(paginator).removeClass('hide');

    addEventHandlerToPageNumbers();
    $(nextPage).on('click', selectNextPage);
    $(previousPage).on('click', selectPreviousPage);
    damHelper.updateImages($('.order-image'));
}

function addEventHandlerToPageNumbers() {
    $(pageNumber).off('click');
    $(pageNumber).on('click',
        (event) => selectPage(Number($(event.target).data('page-number')))
    );
}

function selectPage(selectedPageNumber) {
    $(pageNumber).removeClass('selected');
    $('.js-orders-page:not(.hide)').addClass('hide');
    const $pageToShow = $(`.js-orders-page-${selectedPageNumber}`);
    $pageToShow.removeClass('hide');
    updatePageArrows(selectedPageNumber);
    hidePageNumbers(selectedPageNumber);
    const nextPageToken = $pageToShow.data('next-page-token');
    if (nextPageToken) {
        $pageToShow.addClass('hide');
        $('.js-order-history-spinner').addClass('spinner-visible');
        $(paginator).addClass('hide');
        loadOrderPages(nextPageToken, selectedPageNumber);
    }
    $('.js-page-number[data-page-number="' + selectedPageNumber + '"]').addClass('selected');
}

function selectPreviousPage() {
    selectPage(Number($('.js-orders-page:not(.hide)').data('page-number')) - 1);
}

function selectNextPage() {
    selectPage(Number($('.js-orders-page:not(.hide)').data('page-number')) + 1);
}

function loadOrderPages(pageToken, lastPageNumber) {
    let url = appendParamToURL(Urls.getOrderHistoryPages, 'pageToken', pageToken);
    url = appendParamToURL(url, 'pageNumberStart', lastPageNumber);

    $.get(url)
        .done((responsHtml) => {
            const $newPages = $($.parseHTML(responsHtml));
            $('.js-orders-pages').append($newPages);
            $(`.js-orders-page-${lastPageNumber}`).data('next-page-token', '');
            updatePageNumbers(lastPageNumber, $newPages.filter('.js-orders-page').length);
            $(`.js-orders-page-${lastPageNumber}`).removeClass('hide');
            $('.js-order-history-spinner').removeClass('spinner-visible');
            $(paginator).removeClass('hide');
        })
        .fail((jqXHR, textStatus, errorThrown) => console.log('Failed to load orders: ', errorThrown, textStatus));
}

function updatePageNumbers(startPage, numberOfNewPages) {
    const $pageNumbers = $('.js-page-numbers');

    for (let i = startPage + 1; i <= startPage + numberOfNewPages; i++) {
        $pageNumbers.append(`
            <button type="button" class="account-pagination-item js-page-number" data-page-number="${i}">${i + 1}</button>
        `);
    }

    addEventHandlerToPageNumbers();
}

function hidePageNumbers(selectedPageNumber) {
    $(pageNumber).each(function(index) {
        if ((index < selectedPageNumber - 3) || (index > selectedPageNumber + 3)) {
            $(this).addClass('hide');
            return;
        }

        $(this).removeClass('hide');
    });
}

function updatePageArrows(selectedPageNumber) {
    if (selectedPageNumber) {
        $(previousPage).removeClass('hide');
    } else {
        $(previousPage).addClass('hide');
    }

    if ($('.js-orders-page').length - 1 === selectedPageNumber && !$(`.js-orders-page-${selectedPageNumber}`).data('next-page-token')) {
        $(nextPage).addClass('hide');
        return;
    }

    $(nextPage).removeClass('hide');
}

const orderHistory = {
    init: initialize
};

module.exports = orderHistory;
